<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->

    <BreadCrumb :data="breadcrumb" :title="'遗产详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 学者详情页基本信息 -->
    <div v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="form-content-img">
          <img
            v-if="heritageDetail.cover_image"
            :src="heritageDetail.cover_image"
            alt=""
            class="form-content-img"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
        </div>

        <div class="video">
          <video controls :src="heritageDetail.video"></video>
        </div>

        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名</h4>
            <span>{{ heritageDetail.chinese_name }}</span>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <span>{{ heritageDetail.english_name }}</span>
          </li>
          <li class="half">
            <h4>英文名</h4>
            <span>{{ heritageDetail.area }}</span>
          </li>
          <li class="half">
            <h4>Lat/纬度</h4>
            <span>{{ heritageDetail.lat }}</span>
          </li>
          <li class="half">
            <h4>Lng/经度</h4>
            <span>{{ heritageDetail.lng }}</span>
          </li>

          <li class="one-third">
            <h4>Area</h4>
            <span>{{ heritageDetail.area }}</span>
          </li>
          <li class="one-third">
            <h4>Age</h4>
            <span>{{ heritageDetail.age == 0 ? "" : heritageDetail.age }}</span>
          </li>
          <li class="one-third">
            <h4>Permanent Residents</h4>
            <span>{{ heritageDetail.permanent_residents }}</span>
          </li>
          <li class="exclusive">
            <h4>Total Buildings</h4>
            <span>{{ heritageDetail.total_building }}</span>
          </li>

          <li class="exclusive">
            <h4>Dynasty</h4>
            <span>{{ heritageDetail.protection_agency }}</span>
          </li>
          <li class="half">
            <h4>Core Protection Area</h4>
            <span>{{ heritageDetail.core_protection_area }}</span>
          </li>
          <li class="half">
            <h4>Last Repair Year</h4>
            <span>{{ heritageDetail.last_repair_year }}</span>
          </li>
          <li class="half">
            <h4>History</h4>
            <span>{{ heritageDetail.history }}</span>
          </li>

          <li class="half">
            <h4>Story</h4>
            <span>{{ heritageDetail.story }}</span>
          </li>

          <li class="exclusive">
            <h4>智能文本</h4>
            <span>{{ heritageDetail.qa_text }}</span>
          </li>

          <li class="one-third">
            <h4>所属城市</h4>
            <span v-if="heritageDetail.location">{{
              heritageDetail.location.chinese_name
            }}</span>
          </li>

          <li class="one-third">
            <h4>空间等级</h4>
            <span v-if="heritageDetail.spatial_level">{{
              heritageDetail.spatial_level.chinese_name
            }}</span>
          </li>

          <li class="one-third">
            <h4>保护等级</h4>
            <span v-if="heritageDetail.protection_level">{{
              heritageDetail.protection_level.chinese_name
            }}</span>
          </li>

          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="heritageDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- 修改学者详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="form-content-img">
          <UploadImage
            :img="heritageDetail.cover_image"
            :width="300"
            :height="180"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </div>
        <div class="video">
          <img src="static/image/loading.gif" v-if="isUploadingVideo" alt="" />
          <video
            controls
            :src="heritageDetail.video"
            v-if="!isUploadingVideo"
          ></video>
          <UploadVideo
            @getUploadVideo="getUploadVideo"
            @startUploadVideo="startUploadVideo"
          ></UploadVideo>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名</h4>
            <el-input
              v-model="heritageDetail.chinese_name"
              placeholder="请输入中文名"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <el-input
              v-model="heritageDetail.english_name"
              placeholder="请输入英文名"
            ></el-input>
          </li>
          <li class="half">
            <h4>Lat/纬度</h4>
            <el-input
              v-model="heritageDetail.lat"
              placeholder="请输入纬度"
            ></el-input>
          </li>
          <li class="half">
            <h4>Lng/经度</h4>
            <el-input
              v-model="heritageDetail.lng"
              placeholder="请输入经度"
            ></el-input>
          </li>

          <li class="one-third">
            <h4>Area</h4>
            <el-input
              v-model="heritageDetail.area"
              placeholder="请输入Area"
            ></el-input>
          </li>
          <li class="one-third">
            <h4>Age</h4>
            <el-input-number
              v-model="heritageDetail.age"
              placeholder="请输入Age"
            ></el-input-number>
          </li>
          <li class="one-third">
            <h4>Permanent Residents</h4>
            <el-input
              v-model="heritageDetail.permanent_residents"
              placeholder="请输入Permanent Residents"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>Total Buildings</h4>
            <el-input
              v-model="heritageDetail.total_building"
              placeholder="请输入建筑描述"
            ></el-input>
          </li>

          <li class="exclusive">
            <h4>Dynasty</h4>
            <el-input
              v-model="heritageDetail.protection_agency"
              placeholder="请输入Protection Agency"
            ></el-input>
          </li>
          <li class="half">
            <h4>Core Protection Area</h4>
            <el-input
              v-model="heritageDetail.core_protection_area"
              placeholder="请输入Core Protection Area"
            ></el-input>
          </li>
          <li class="half">
            <h4>Last Repair Year</h4>
            <el-input
              v-model="heritageDetail.last_repair_year"
              placeholder="请输入Last Repair Year"
            ></el-input>
          </li>
          <li class="half">
            <h4>History</h4>
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="heritageDetail.history"
            >
            </el-input>
          </li>

          <li class="half">
            <h4>Story</h4>
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="heritageDetail.story"
            >
            </el-input>
          </li>

          <li class="exclusive">
            <h4>智能文本</h4>
            <el-input
              type="textarea"
              :rows="15"
              placeholder="请输入内容"
              v-model="heritageDetail.qa_text"
            >
            </el-input>
          </li>

          <li class="one-third">
            <h4>所属城市</h4>
            <el-select
              v-model="heritageDetail.location.id"
              clearable
              placeholder="所属城市"
              class="tag"
            >
              <el-option
                v-for="(item, index) in loactionList"
                :key="index"
                :label="item.chinese_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>

          <li class="one-third">
            <h4>空间等级</h4>
            <el-select
              v-model="heritageDetail.spatial_level.id"
              clearable
              placeholder="空间等级"
              class="tag"
            >
              <el-option
                v-for="(item, index) in spatialLevelList"
                :key="index"
                :label="item.chinese_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>

          <li class="one-third">
            <h4>保护等级</h4>
            <el-select
              v-model="heritageDetail.protection_level.id"
              clearable
              placeholder="词条分类"
              class="tag"
            >
              <el-option
                v-for="(item, index) in protectionLevelList"
                :key="index"
                :label="item.chinese_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>

          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="heritageDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <div class="heritage-images">
      <h2>遗产图片</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadHeritageImage"
          class="form-content-img upload-image"
        ></UploadImage>
        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in heritageDetail.images"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImage(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="pc-dataDetail-intro">
      <h2>词条介绍</h2>
      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="15"
          placeholder="请输入内容"
          v-model="heritageDetail.chinese_detail"
        >
        </el-input>
        <p v-else>
          {{ heritageDetail.chinese_detail }}
        </p>
      </div>
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          v-if="isEditting"
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="heritageDetail.english_detail"
        >
        </el-input>
        <p v-else>
          {{ heritageDetail.english_detail }}
        </p>
      </div>
    </div> -->
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
    <ModelManage v-if="$route.query.method == 'update'" />
  </div>
</template>
<script>
import ModelManage from "./components/ModelManage";
import UploadVideo from "./components/UploadVideo";
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import { city_Api } from "../../../apis/tools.api";
import {
  heritageDetail_Api,
  createHeritageDetail_Api,
  updateHeritageDetail_Api,
  getProtectionLevel_Api,
  getSpatialLevel_Api,
} from "@/apis/heritage.api";
export default {
  components: {
    ModelManage,
    UploadVideo,
    UploadImage,
    BreadCrumb,
    SaveGroup,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "遗产列表", link: "/admin/heritageList" },
        {
          name: `${
            (
              this.heritageDetail.chinese_name
                ? this.heritageDetail.chinese_name
                : this.heritageDetail.english_name
            )
              ? this.heritageDetail.chinese_name
                ? this.heritageDetail.chinese_name
                : this.heritageDetail.english_name
              : ""
          }`,
          link: "/admin/heritagedetail",
        },
      ];
    },
  },
  data() {
    return {
      isUploadingVideo: false,
      isEditting: false,
      heritageDetail: {
        id: null,
        location: { chinese_name: "" },
        protection_level: { chinese_name: "" },
        spatial_level: { chinese_name: "" },
      },
      loactionList: [],
      spatialLevelList: [],
      protectionLevelList: [],
    };
  },
  filters: {
    authorName: function (val) {
      val.forEach((element) => {
        console.log(element);
      });
    },
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.heritageDetail.id = this.$route.query.id;
      this.getHeritageDetail();
    } else {
      this.isEditting = true;
    }
    city_Api().then((res) => {
      this.loactionList = res.data;
    });
    getProtectionLevel_Api().then((res) => {
      this.protectionLevelList = res.data;
    });
    getSpatialLevel_Api().then((res) => {
      this.spatialLevelList = res.data;
    });
  },

  methods: {
    removeImage(index) {
      this.heritageDetail.images.splice(index, 1);
    },
    getUploadVideo(data) {
      this.isUploadingVideo = false;

      this.heritageDetail.video = data;
      console.log(data, this.heritageDetail.video);
    },
    startUploadVideo() {
      this.isUploadingVideo = true;
    },
    getUploadHeritageImage(img_url) {
      this.heritageDetail.images.unshift(img_url);
      console.log(this.heritageDetail.images);
      // this.heritageDetail.images = img_url;
    },

    searchHeritage(queryString, callback) {},
    getUploadImage(img_url) {
      this.heritageDetail.cover_image = img_url;
    },
    getHeritageDetail(hint) {
      heritageDetail_Api(this.heritageDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.heritageDetail = res.data;

        console.log(this.heritageDetail.author_chinese_name);
        this.heritageDetail.location == null
          ? (this.heritageDetail.location = { chinese_name: "" })
          : "";
        this.heritageDetail.spatial_level == null
          ? (this.heritageDetail.spatial_level = { chinese_name: "" })
          : "";
        this.heritageDetail.protection_level == null
          ? (this.heritageDetail.protection_level = { chinese_name: "" })
          : "";
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getHeritageDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getHeritageDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/heritage/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.heritageDetail);
      if (!formattedData) {
        return;
      } else {
        createHeritageDetail_Api(formattedData)
          .then((res) => {
            this.heritageDetail.id = res.data.id;
            this.isEditting = false;
            this.getHeritageDetail();
            this.$router.push({
              path: "/admin/heritagedetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.heritageDetail);
      if (!formattedData) {
        return;
      } else {
        updateHeritageDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getHeritageDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      formData.location_id = formData.location.id;
      formData.spatial_level_id = formData.spatial_level.id;
      formData.protection_level_id = formData.protection_level.id;
      formData.images_list = formData.images;

      formData.heritage_id = formData.id;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.heritage-images {
  @include box-model;
  .images-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        img {
          height: 140px;
        }
        .el-icon-error {
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
/deep/ .keywordsTag {
  width: 100%;
}
.form-content-img {
  position: relative;
  width: 300px;
  height: 200px;
}
.video {
  position: absolute;
  top: 380px;
  video {
    width: 300px;
    display: block;
  }
  img {
    width: 300px;
    height: 170px;
    object-fit: cover;
  }
}

/deep/ .el-select {
  width: 100%;
}

.no-img {
  width: 200px !important;
  height: 150px !important;
}
/deep/ .keywordsTag {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/iHeritage/HeritageDetail.vue